import React from "react"
import { Flex, Box } from "theme-ui"
import _ from "lodash"
import { faMinus } from '@fortawesome/free-solid-svg-icons'

import TextField from "../Radiate/TextField/TextField"
import NewBoxButton from "../Radiate/NewBoxButton/NewBoxButton"

const InfoWithAlias = ({
  phone,
  website,
  email,
  onChangeInfo,
  index,
  businessInfo,
  key1,
  key2,
}) => {
  let label
  if (phone) {
    label="Phone"
  } else if (website) {
    label = "Website"
  } else if (email) {
    label = "Email"
  }

  const onChangeValue = ({ key, value, subKey }) => {
    const clone = _.cloneDeep(businessInfo)
    clone.profile[key][index][subKey] = value
    onChangeInfo(clone)
  }
  return (
    <Flex
      mb={1}
      mx={1}
    >
      <Box pr={2}>
        <TextField
          label="Title"
          borderStyle
          useInput
          value={businessInfo.profile[key1][index].alias}
          onChange={(e) => {
            onChangeValue({ key: key1, value: e.target.value, subKey: "alias" })
          }}
        />
      </Box>
      <Box pr={2} sx={{ flexGrow: "1" }}>
        <TextField
          label={label}
          borderStyle
          useInput
          value={businessInfo.profile[key1][index][key2]}
          onChange={(e) => {
            onChangeValue({ key: key1, value: e.target.value, subKey: key2 })
          }}
        />
      </Box>
      <Box pt={3}>
        <NewBoxButton
          icon={faMinus}
          onClick={() => {
            const clone = _.cloneDeep(businessInfo)
            const modArray = [
              ...businessInfo.profile[key1].slice(0, index),
              ...businessInfo.profile[key1].slice(index + 1)
            ]
            clone.profile[key1] = modArray
            onChangeInfo(clone)
          }}
        />
      </Box>
    </Flex>
  )
}

export default InfoWithAlias